// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2mwcZ","inputWrap":"styles_inputWrap__3nZMb","input":"styles_input__2d-TD"};